import { render, staticRenderFns } from "./AppCreateNewDialog.vue?vue&type=template&id=1c945e47&"
import script from "./AppCreateNewDialog.vue?vue&type=script&lang=ts&"
export * from "./AppCreateNewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports